angular.module('admin.directives')

.directive('agentClientList', ['Dictionary', 'AgentService', 'UtilService', '$window', function(Dictionary, AgentService, UtilService, $window){
  return {
    restrict: 'EA',
    controllerAs: 'listCtrl',
    bindToController: {
      agent: '=',
      currentPage: '@',
      listType: '@',
      onSortChange: '&',
      clientListSort: '@',
      clientListOrder: '@',
      pageLimit: '@',
      searchQuery: '@',
    },
    scope: {},
    templateUrl: function(el, attrs){
      return attrs.templateUrl || '/admin/templates/partials/agent-client-list.html';
    },

    controller: function(){
      var ctrl = this;
      var dictionary = new Dictionary();


      ctrl.lookup = function(prop,home){
        return dictionary[prop](home);
      };

      ctrl.doSearch = function(){
        let page = parseInt(ctrl.currentPage, 10);
        let limit = parseInt(ctrl.pageLimit, 10);
        let offset = (page - 1) * limit;

        if(ctrl.listType === 'needsCMA')
          return AgentService.needsCMA(ctrl.agent.id);
        else
          return AgentService.searchHomes(ctrl.agent.id, ctrl.searchQuery, ctrl.pageLimit, offset, ctrl.clientListSort, ctrl.clientListOrder);
      }

      ctrl.getHomes = function(){
        ctrl.error = '';
        ctrl.loading = true;

        ctrl.doSearch()
          .then((data) => {
            ctrl.homes = data;
            ctrl.loading = false;
          })
          .catch((err) => {
            ctrl.loading = false;
            ctrl.error = 'There was an error getting your list of homes.';
            utils.trackException('Get All Homes', err);
          });
      }

      ctrl.sort = (sort) => {
        ctrl.onSortChange({sort: sort});
      };

      ctrl.getHomes();
    },

    link: function($scope, el, attrs, ctrl){
      $scope.$watchGroup([
          'listCtrl.listType',
          'listCtrl.searchQuery',
          'listCtrl.currentPage',
          'listCtrl.clientListSort',
          'listCtrl.clientListOrder',
        ],
        ctrl.getHomes);
    }

  }

}]);
